import { MeetPage } from './meet-page'

export default MeetPage
